import React from 'react';
import { motion } from 'framer-motion';

const techStack = [
  { category: 'Frontend', items: ['React', 'Next.js', 'Vue.js', 'Angular'] },
  { category: 'Backend', items: ['Node.js', 'Python', 'Java', 'PHP', 'ASP.NET'] },
  { category: 'Mobile', items: ['React Native', 'Flutter', 'iOS', 'Android'] },
  { category: 'Cloud & DevOps', items: ['AWS', 'Azure', 'Docker', 'Google Cloud', 'CI/CD'] },
  { category: 'no-code / low-code tools', items: ['Zapier', 'n8n', 'Make.com'] }
];

const Technologies = () => {
  return (
    <section id="technologies" className="py-24 bg-slate-50/40 backdrop-blur-md relative border-t border-slate-200/50">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="flex flex-col md:flex-row gap-12 items-center">
          
          <div className="flex-1">
            <motion.h2 
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="text-4xl md:text-5xl font-bold text-slate-900 mb-6"
            >
              Technologies We <br/> Work With
            </motion.h2>
            <motion.p 
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="text-lg text-slate-600 mb-8 max-w-xl"
            >
              We leverage modern and proven technologies to build secure, scalable software products that stand the test of time and support your growth.
            </motion.p>
            <motion.button 
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="bg-white border-2 border-slate-200 text-slate-800 px-8 py-3 rounded-full font-semibold hover:border-slate-300 hover:bg-slate-50 transition-colors"
            >
              View All Technologies
            </motion.button>
          </div>

          <div className="flex-1 w-full grid gap-4">
            {techStack.map((stack, idx) => (
              <motion.div 
                key={stack.category}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1 }}
                className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm"
              >
                <h3 className="text-sm uppercase tracking-wider font-bold text-blue-600 mb-3">{stack.category}</h3>
                <div className="flex flex-wrap gap-2">
                  {stack.items.map(tech => (
                    <span key={tech} className="px-3 py-1 bg-slate-50 text-slate-700 text-sm font-medium rounded-full border border-slate-100">
                      {tech}
                    </span>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default Technologies;
